import { render, staticRenderFns } from "./GrNavLinkDense.vue?vue&type=template&id=11fff2ab&scoped=true&"
import script from "./GrNavLinkDense.vue?vue&type=script&lang=ts&"
export * from "./GrNavLinkDense.vue?vue&type=script&lang=ts&"
import style0 from "./GrNavLinkDense.vue?vue&type=style&index=0&id=11fff2ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fff2ab",
  null
  
)

export default component.exports